import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import filters from './filters'
import '../node_modules/viewerjs/dist/viewer.css'
import './assets/iconfont/custom-font.css'
import Viewer from 'v-viewer'
import axios from 'axios'
import {Result, Alert, Button, Input, Modal, Select, Checkbox, Switch, FormModel, message, notification, Carousel, Icon, Timeline, Radio, Breadcrumb, Dropdown, Menu, DatePicker, Cascader, Spin} from 'ant-design-vue'
import VueQrcode from '@chenfengyuan/vue-qrcode';
import VueYouTubeEmbed from 'vue-youtube-embed'
Vue.prototype.$message = message
Vue.prototype.$confirm = Modal.confirm
Vue.prototype.$notification = notification
Vue.prototype.$axios = axios
Vue.config.productionTip = false
Vue.use(Viewer)
Vue.use(VueYouTubeEmbed)
// inline	布尔值	false	启用 inline 模式
// button	布尔值	true	显示右上角关闭按钮（jQuery 版本无效）
// navbar	布尔值/整型	true	显示缩略图导航
// title	布尔值/整型	true	显示当前图片的标题（现实 alt 属性及图片尺寸）
// toolbar	布尔值/整型	true	显示工具栏
// tooltip	布尔值	true	显示缩放百分比
// movable	布尔值	true	图片是否可移动
// zoomable	布尔值	true	图片是否可缩放
// rotatable	布尔值	true	图片是否可旋转
// scalable	布尔值	true	图片是否可翻转
// transition	布尔值	true	使用 CSS3 过度
// fullscreen	布尔值	true	播放时是否全屏
// keyboard	布尔值	true	是否支持键盘
// interval	整型	5000	播放间隔，单位为毫秒
// zoomRatio	浮点型	0.1	鼠标滚动时的缩放比例
// minZoomRatio	浮点型	0.01	最小缩放比例
// maxZoomRatio	数字	100	最大缩放比例
// zIndex	数字	2015	设置图片查看器 modal 模式时的 z-index
// zIndexInline	数字	0	设置图片查看器 inline 模式时的 z-index
// url	字符串/函数	src	设置大图片的 url
// build	函数	null	回调函数，具体查看演示
// built	函数	null	回调函数，具体查看演示
// show	函数	null	回调函数，具体查看演示
// shown	函数	null	回调函数，具体查看演示
// hide	函数	null	回调函数，具体查看演示
// hidden	函数	null	回调函数，具体查看演示
// view	函数	null	回调函数，具体查看演示
// viewed	函数	null	回调函数，具体查看演示
Vue.use(Spin)
Vue.use(Button)
Vue.use(Modal)
Vue.use(FormModel)
Vue.use(Input)
Vue.use(Alert)
Vue.use(Select)
Vue.use(Checkbox)
Vue.use(Switch)
Vue.use(Icon)
Vue.use(Carousel)
Vue.use(Timeline)
Vue.use(Radio)
Vue.use(Breadcrumb)
Vue.use(Dropdown)
Vue.use(Menu)
Vue.use(DatePicker)
Vue.use(Cascader)
Vue.use(Result)
Vue.component(VueQrcode.name, VueQrcode);

// 全局过滤器
Object.keys(filters).forEach(filterName => {
    Vue.filter(filterName, filters[filterName])
})

new Vue({
  router,
  store,
  render: h => h(App),
  mounted() {
    document.dispatchEvent(new Event('render-event'));
  },
}).$mount('#app')
